// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// INNER IMPORTS
import Datepicker from './Datepicker';
import DropdownMobileFilterBar from './DropdownMobileFilterBar';
import { LIVE_MUSIC } from '../../consts';
import { isSmallMobile } from '../../utils';

// svgs
//import locationBlueSVG from '../inlineSVGs/locationBlueSVG';
// import calenderSVG from '../inlineSVGs/calenderSVG';

import * as actions from '../../Actions/main';
import './MapTopBarMobile.css';
import {AnalyticsService} from "../../Services";

class MapTopBarMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isStickBar: false
        }
    }

    componentDidMount() {
    }

    // On user changed dates - add the dates filters accordingly and reload the pins
    handleChangeDates(startDate, endDate, chosenLabel) {
        this.props.addFilter('begins', startDate)
        this.props.addFilter('ends', endDate)
        this.props.setChosenDateLabel(chosenLabel);

        setTimeout(() => {
            //this.props.getPinsCall(this.props.filters);
            //this.props.getMapPinsCall(this.props.filters);
        }, 500)
    }

    // If user chose a location, the map should focus on that location
    handleChangePlace(place) {

        if (!place || !place.geometry || !place.geometry.location) return;

        this.props.changeLocationOnMap(place.geometry.location.lat(), place.geometry.location.lng());

        if (!place.geometry.viewport || !place.geometry.viewport.ha || !place.geometry.viewport.da) return;

        const locationObj = {}
        if(place.address_components) {
            place.address_components.forEach(addr => {
                locationObj[addr.types[0]] = addr.long_name
            })
        }

        const area = {
            top: place.geometry.viewport.ha.h, // place.geometry.viewport.f.f,
            bottom: place.geometry.viewport.ha.g, // place.geometry.viewport.f.b,
            left: place.geometry.viewport.da.g, // place.geometry.viewport.b.b,
            right: place.geometry.viewport.da.h, // place.geometry.viewport.b.f
            ...locationObj
        };

        // new api change on google maps:
        // google API is not clear so:
        //  geometry.viewport.na.l = north
        //  geometry.viewport.na.j = south
        //  geometry.viewport.ga.j = west
        //  geometry.viewport.fga.l = east

        // old api - keeping here for ref
        // google API is not clear so:
        //  geometry.viewport.b.f = east
        //  geometry.viewport.b.b = west
        //  geometry.viewport.f.b = south
        //  geometry.viewport.f.f = north
        this.props.addFilter('location', area)

        setTimeout(() => {
            //this.props.getPinsCall(this.props.filters);
            //this.props.getMapPinsCall(this.props.filters);
        }, 500)
    }

    // If the user changes the type (Services/Live music), the filters should change accordingly and reload the pins
    // We should remove previous category and subCategory as well
    handleTypeSelect(type) {
        this.props.resetFiltersType(type);

        window.location = `/#${type}`;
        AnalyticsService.sendEvent(AnalyticsService.events.TOP_FILTER, type, null, { type });
    }

    handleLocationChange(value) {
        if (!value) {
            this.props.addFilter('location', null);

            setTimeout(() => {
                //this.props.getPinsCall(this.props.filters);
                //this.props.getMapPinsCall(this.props.filters);
            }, 500)
        }
    }

    handleStickyBar() {
        if (!this.props.isStickyBar) return '';
        return 'sticky-bar';
    }

    renderDatePicker() {
        if (!this.props.filters || this.props.filters.type !== LIVE_MUSIC) return null;

        return (
            <Datepicker
                isCaretMobile
                datatypes={this.props.datatypes}
                onDatesChange={this.handleChangeDates.bind(this)}
            />
        )
    }

    render() {
        if (!this.props || !this.props.datatypes) return null;

        // 0.0725
        return (
            <div
                className={`mapTopBarMobile rtl ${this.props.filters.type} ${isSmallMobile() ? 'smallDevice ' : ''}${this.handleStickyBar()}`}
                style={{top: this.props.isStickyBar ? 80 : 0}}
            >
                <DropdownMobileFilterBar
                    options={this.props.datatypes.types.map((type) => {
                        return {name: type.name, text: type.fullText}
                    })}
                    selected={this.props.filters.type}
                    onChange={type => this.handleTypeSelect(type)}
                />
                {this.renderDatePicker()}
            </div>
        )
    }
}

MapTopBarMobile.propTypes = {
    getMapPinsCall: PropTypes.func,
    getPinsCall: PropTypes.func,
    changeLocationOnMap: PropTypes.func,
    isStickyBar: PropTypes.bool,
    filters: PropTypes.object,
    addFilter: PropTypes.func,
    updateFilters: PropTypes.func,
    resetFiltersType: PropTypes.func,
    datatypes: PropTypes.object,
    setChosenDateLabel: PropTypes.func
};

const mapStateToProps = state => ({
    datatypes: state.main.datatypes
});

// connecting the component to the actions in order to be able to dispatch them from the component
export const MapTopBarMobileContainer = connect(mapStateToProps, actions)(MapTopBarMobile);

export default MapTopBarMobile;



// WEBPACK FOOTER //
// ./src/Components/Main/MapTopBarMobile.js